import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRowData} from "../../constants/Table/interfaces";

interface IDeliveryReducer {
    editingRow: IRowData | null;
    isDeliveryFormModalOpen: boolean;
}

const initialState: IDeliveryReducer = {
    editingRow: null,
    isDeliveryFormModalOpen: false
}

const deliveryStateSlice = createSlice({
    name: 'delivery',
    initialState,
    reducers: {
        setIsDeliveryFormModalOpen(state, action: PayloadAction<boolean>) {
            state.isDeliveryFormModalOpen = action.payload;
        },
        setEditingRow(state, action: PayloadAction<IRowData>) {
            state.editingRow = action.payload;
        },
        resetEditingRow(state) {
            state.editingRow = null;
        },
    },
});

const delivery = deliveryStateSlice.reducer;

export const {
    setIsDeliveryFormModalOpen,
    setEditingRow,
    resetEditingRow
} = deliveryStateSlice.actions;

export default delivery